// @flow

import * as types from '../actionTypes';
import {
  createActionBundleForNestedMany,
  createActionBundleForNestedSingle,
} from '../utils';

export const getInvoiceActions = {
  ...createActionBundleForNestedSingle(types.GET_INVOICE_ASYNC),
  ifNeeded: () => {
    throw new Error('This should not be used.');
  },
  pending: () => {
    throw new Error('This should not be used.');
  },
};
export const getInvoiceListActions = createActionBundleForNestedMany(
  types.GET_INVOICE_ASYNC,
);
